import { VERSION } from '@angular/core';

import { mcApi } from './mc-api-methods.const';
import { mcNotificationHub } from './mc-notification-hub.consts';
import { AppConfig } from '../config.contract';

export let EXTERNAL_CONFIG = {
    isLoaded: false,
    appConfig: {} as AppConfig
};

export let CONST_CONFIG = {
    apiMethods: {
        mcApi
    },
    mcNotificationHub,
    angularVersion: VERSION
};



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/config/constants/const.config.ts